var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"landing-section"},[_c('header',{staticClass:"landing-section__header"},[_c('h3',{staticClass:"landing-section__title"},[_vm._v(_vm._s(_vm.title))])]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }